import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
import Icon from '../Icon';
import Typography from '../Typography';
import Button from '../Button';
import './Dropdown.css';

const Dropdown = ({
  label = 'Select option',
  options = [],
  className,
  onSelect,
  error,
  setError,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
    setError(null);
    if (onSelect) onSelect(option);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={clsx('alf-dropdown', className)}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={clsx(
          'dropdown-button',
          isOpen && 'open',
          selected && 'selected',
          error && 'error',
        )}
        data-testid="dropdown-button"
      >
        {selected?.label || label}
        <span className="dropdown-span">
          <Icon
            alt="Toggle group"
            id="dropdown-icon"
            name={isOpen ? 'chevronUp' : 'chevronDown'}
            fontSize={12}
            color="#5b564d"
            onClick={() => setIsOpen(!isOpen)}
            className="dropdown-icon"
            style={{ marginLeft: 5, marginTop: 0 }}
          />
        </span>
      </button>
      {error && !isOpen && (
        <Typography type="error" component="p">
          {error}
        </Typography>
      )}

      {isOpen && (
        <ul className="dropdown-menu">
          {options.map((option, index) => (
            <li
              key={index}
              className={clsx(
                'dropdown-option',
                option === selected && 'selected',
              )}
            >
              <Button
                id={`option-${index}`}
                type="icon"
                onClick={() => handleSelect(option)}
                className="w-full bg-transparent border-0 text-left p-0 text-inherit hover:text-inherit"
                onMouseEnter={(e) => (e.target.style.background = '#f2f2f2')}
                onMouseLeave={(e) =>
                  (e.target.style.background =
                    option === selected ? '#efebff' : 'transparent')
                }
              >
                {option.label}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Dropdown;
